<template>
  <div>
    <el-row
        type="flex"
        align="middle"
        justify="space-between"
        class="nav-bar">
      <el-row type="flex" class="nav-bar--left">
        <gj-link route-to="/dashboard">
          <gj-icon iconfont="iconlogo" class="nav-bar--left__logo"></gj-icon>
        </gj-link>
        <span class="watermark">M版</span>
        <el-menu
          ref="menu"
          menu-trigger="hover"
          :default-active="activeMenuIndex"
          mode="horizontal"
          class="nav-bar--left__menu">
          <el-submenu
              v-for="menu in userMenus"
              :index="menu.id"
              :key="menu.id"
              popper-class="gj-nar-bar--module-menu">
            <template #title>
<!--              <span :class="{active: $route.meta.modal === menu.label}"> {{ menu.label }}</span>-->
              <span :class="{active: activeMenuId === menu.id}"> {{ menu.label }}</span> 
            </template>
            <template #default>
              <div style="display: flex; padding: 7px 0;">
                <div v-for="(moduleMenu, index) in menu.children"
                     :key="moduleMenu.id"
                     :class="{'menu-col': true, 'menu-col-border': (index + 1) !== menu.children.length}">
                  <div class="menu__module--title">
                      <i class="menu__module--icon iconfont iconplanet" style="height: 16px; top: -4px;" v-if="moduleMenu.icon == 'planet-tool'"></i>
                      <gj-icon class="menu__module--icon" v-else :iconfont="icons[moduleMenu.id]"></gj-icon>
                      <span>{{ moduleMenu.label }}</span>
                    <template v-if="waitOnlineTab(moduleMenu.label)">
                      <span class="wait-online">即将上线</span>
                    </template>
                  </div>
                  <div v-for="routeMenu in moduleMenu.children"
                      :key="routeMenu.id"
                       @click="menuClick(routeMenu.label, menu.id)">
                      <gj-link
                        v-if="routeMenu.component == '/tool/amazon-ad'"
                        href="https://learningconsole.amazonadvertising.com/sl/7f9bff07"
                        target="_blank">
                      <div class="menu__route-link--label">{{routeMenu.label | defaultShow}}</div>
                    </gj-link>
                    <gj-link
                        v-else
                        :route-to="routeMenu.component"
                        router-tag="div"
                        class="menu__route-link">
                      <div class="menu__route-link--label" style="position: relative;">
                        <span >{{routeMenu.label | defaultShow}}</span>
                        <gj-icon class="menu-icon-color" v-if="childrenIcons[routeMenu.id]" :iconfont="childrenIcons[routeMenu.id]"></gj-icon>
                      </div>
                    </gj-link>
                  </div>
                </div>
              </div>
            </template>
          </el-submenu>
        </el-menu>
      </el-row>
        <app-info-bar ref="infoBar" @cutNavState="state => $emit('cutNavState', state)"></app-info-bar>
    </el-row>
  </div>
</template>

<script>
  import {SET_USER_GUIDE_STATE} from "@/store/mutation-types";
  import {isMeaningfulMixin, keepAliveMixin, userInfoMixIn, kefuMixin} from "../../../minxins";
  import {mapGetters} from "vuex";
  import AppInfoBar from './app-info-bar.vue'

  export default {
    name: "app-nav-bar",
    components: {
        AppInfoBar
    },
    mixins: [userInfoMixIn, isMeaningfulMixin, keepAliveMixin, kefuMixin],
    data() {
      return {
        firstRender: true, // 判断是否是首次进入
        activeMenuIndex: '1',
        icons:{
          '10201': 'iconchanpinguanli',
          '10301': 'iconchanpinguanli',
          '10302': 'icondingdan',
          '10303': 'iconshujubaogao',
          '10304': 'iconguanggaofenxi',//
          '10305': 'iconguanggaofenxi',//
          '10401': 'iconcaigouguanli',
          '10402': 'iconjichupeizhi',
          '10501': 'iconkucunguanli',
          '10502': 'iconkucuncaozuo',
          '10503': 'iconjichupeizhi',
          '10601': 'iconfahuoguanli',
          '10602': 'iconjichupeizhi',
          '10701': 'iconguanggaoguanli',
          '10702': 'iconguanggaogongju',
          '10703': 'iconguanggaofenxi',
          '10750': 'iconpinkong1', 
          '10801': 'iconkefuyoujian',
          '10803': 'iconhuifu',
          '10804': 'iconcaiwubaobiao',//
          '10901': 'iconcaiwubaobiao',
          '10902': 'iconchengbenguanli',
          '11003': 'iconyunyingfenxi',
          '11001': 'iconxiaoshoufenxi',
          '11002': 'iconyamaxunbaobiao',
          '11004': 'iconjixiao',
          '11101': 'iconyunyinggongju',
          '11103': 'iconjijiayunzhushou',
          '11201': 'iconquanxianguanli',
          '11202': 'iconjichuxinxi',
          '11203': 'icondianpuguanli',
          '11206': 'iconshezhi2',
          '11301': 'iconjichupeizhi',
          '11302': 'iconshezhi2'
        },
        childrenIcons: {
          '1070201': 'iconnew4'
        },
        kefuLink: 'https://wp.qiye.qq.com/qidian/3009000551/2ccb4a0cbe0dee0415a3fdb8e310e1eb'
      }
    },
    computed: {
      ...mapGetters(['userMenus', 'userInfo', 'userGuideMenuPath', 'userGuideState']),
      // 计算当前路由页的最上级菜单id
      activeMenuId(){
        if(!this.userMenus) return ''
        for(let menu of this.userMenus){
          if(!menu.children) break
          for(let moduleMenu of menu.children){
            if(!moduleMenu.children) break
            for(let routeMenu of moduleMenu.children){
              if(routeMenu.component === this.$route.path){
                return menu.id
              }
            }
          }
        }
        return ''
      }
    },
    watch: {
      userGuideMenuPath: {
        handler(newPath, oldPath) {
          if(newPath) this.menuAuto(newPath, 'open')
          else if(!newPath && oldPath) this.menuAuto(oldPath, 'close')
        }
      }
    },
    created() {
      // 有路由重定向则设置改变
      let redirect = sessionStorage.getItem("redirect")
      if (redirect) {
        this.$router.replace(redirect);
        sessionStorage.setItem("redirect", "")
      }
    },
    methods: {
      menuClick(menuName, id) {
        this.$refs.menu.close(id)
        // 在用户引导模式中，通过菜单导航跳转视为自动退出指引模式
        if(this.userGuideState) {
          this.$store.commit(SET_USER_GUIDE_STATE, false);
        }
        if (window._czc) {
          const userInfo = `${this.userInfo.tenant}+${this.userInfo.account}`;
          window._czc.push(['_trackEvent', '页面访问量', menuName, userInfo]);
        }
      },
      // 是否为即将上线的tab
      waitOnlineTab(label) {
        return [].includes(label);
      },
      // 新手任务控制菜单栏展示隐藏
      menuAuto(path, type) {
        if(!this.userMenus) return false
        let menuId = ''
        for(let menu of this.userMenus){
          if(!menu.children) break
          for(let moduleMenu of menu.children){
            if(!moduleMenu.children) break
            for(let routeMenu of moduleMenu.children){
              if(routeMenu.component === path){
                menuId = menu.id
              }
            }
          }
        }
        if(menuId && type == 'open') {
          this.$refs.menu.open(menuId)
        }
        if(menuId && type == 'close') {
          this.$refs.menu.close(menuId)
        }
      },
      removeTabList(arr) {
        arr.forEach(i => {
          this.removeTabCallback(i, false)
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables.scss';
  .nav-bar--left__logo {
    margin: 0 10px;
    /deep/ .gj-icon{
      font-size: 36px;
    }
  }
  .menu__module--icon {
    position: absolute;
    top: 0;
    left: 16px;
    /deep/ .gj-icon{
      font-size: 16px;
    }
  }

  .nav-bar {
    height: 40px;
    padding: 0 20px;
    background: $gj-background-color-bg11;
  }
  .nav-bar--left {
    height: 100%;
    align-items: center;
    /* padding-left: 10px; */
  }
  .watermark {
    display: block;
    width: 32px;
    height: 20px;
    border: 1px solid #D8DADD;
    border-radius: 2px;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #D8DADD;
    box-sizing: border-box;
  }

  .nav-bar--right {
    align-items: center;
  }
  .nav-bar--left__menu {
    border: none !important;
    background: unset;
  }
  
  .nav-bar--right__notice {
    margin: 8px 22px 5px 0;
    font-size: 23px;
    color: #fff;
  }
  .nav-bar--right__notice /deep/ .el-badge__content {
    height: 14px;
    line-height: 14px;
    padding: 0 4px;
    top: 4px;
  }
  .nav-bar--right__user {
    color: #fff;
  }
  .nav-bar--right__user--avatar {
    height: 24px;
    width: 24px;
  }
  .nav-bar--right__user--name {
    margin: 0 12px;
    color: #fff;
  }


  /deep/ .el-submenu__title {
    height: 40px !important;
    line-height: 36px !important;
    border-bottom: none !important;
    font-size: 16px;
    font-weight: 700;
    color: $gj-line-color-grey5 !important;
    background: $gj-background-color-bg11;
  }
  /deep/ .el-submenu__title:hover {
    color: #fff !important;
    background: $gj-background-color-bg11 !important;
  }
  /deep/ .el-submenu__icon-arrow {
    display: none;
  }
  .wait-online {
    color: rgb(255, 63, 72);
    font-style: italic;
    transform: scale(0.85);
    display: inline-block;
    font-size: 12px;
    font-weight: normal;
  }
  /* 菜单样式 */
  .menu-col {
    position: relative;
    line-height: 2.5;
    width: 180px;
    padding-left: 40px;
    box-sizing: border-box;
  }
  .menu-col-border {
    border-right: 1px solid rgba(246, 246, 248, .2);
  }
  .menu__module--title {
    font-weight: bold;
    color: #6e767e;
    font-size: 13px;
  }
  
  .menu__route-link--label {
    width: 100%;
    color: rgba(255, 255, 255, 0.65);
    font-size: 14px;
  }
  .menu__route-link {
    display: inline-block;
    width: 100%;
    justify-content: flex-start;
    text-align: left;
    /deep/ .el-link--inner{
      display: inline-block;
      width: 100%;
    }
  }
  .menu__route-link:hover .menu__route-link--label {
    color: white;
  }
  /deep/ .el-tabs__nav-next,
  /deep/ .el-tabs__nav-prev {
    line-height: 32px;
  }
  .relate-us {
    cursor: pointer;
    color: #fff;
    /* margin-right: 14px;
    margin-bottom: 4px; */
    font-size: 16px;
    padding: 0 14px;
  }

  /deep/ .el-badge{
    vertical-align: baseline;
  }
  .active{
    color: $gj-font-color-b3;
  }
  .menu-icon-color{
    position: absolute;
    top: -17px;
    color: #F5824F;
    margin-left: 4px; 
    font-size: 28px;
  }
</style>
